/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import { call, debounce, put, select } from 'redux-saga/effects';
import * as T from '../actions';
import { isSearching, sessionListSearch, sessionListTab } from '../data/prefabs';
import { selectInitedStateful } from '../../common/sagas';

export function* handleSearchSessions({ payload }) {
  const sessionListTabIndex = yield select(sessionListTab.value);
  if (sessionListTabIndex !== 0) {
    return;
  }

  const stateful = yield call(selectInitedStateful);
  const search = yield select(sessionListSearch.value);

  if (search) {
    yield call([stateful, 'searchSessions'], { search, ...payload });
  }
  yield put(isSearching.turnOffAction);
}

export default function* watchSearchSessionsSaga() {
  yield debounce(250, T.SEARCH_SESSIONS, handleSearchSessions);
}
